import {
  SkeletonContentSwitcher,
  SkeletonPillShape,
  SkeletonRectangle,
} from '@xing-com/skeleton';
import {
  scale080,
  scale090,
  scale100,
  scale110,
  scale140,
} from '@xing-com/tokens';

import * as Styled from './perk-list.styled';

const skeletonGroupRowCounts = [4, 4, 3] as const;

export const PerkListSkeleton: React.FC = () => {
  return (
    <Styled.Section aria-busy="true" data-qa="perk-list-skeleton">
      <Styled.Overview>
        <Styled.SkeletonOverviewHeading height={scale140} />
        <SkeletonContentSwitcher amount={2} size="medium" />
      </Styled.Overview>

      <Styled.ProductHeader>
        <Styled.ProductTitle>
          <Styled.SkeletonProductTitle height={scale140} />
        </Styled.ProductTitle>
        <Styled.Intro>
          <Styled.SkeletonIntro data-qa="perk-list-skeleton-intro">
            <SkeletonRectangle height={scale090} />
            <SkeletonRectangle height={scale090} />
            <SkeletonRectangle height={scale090} width="66%" />
          </Styled.SkeletonIntro>
        </Styled.Intro>
        <Styled.SkeletonActivationButton size="large" />
      </Styled.ProductHeader>

      <Styled.Groups>
        {skeletonGroupRowCounts.map((perkRows, index) => (
          <Styled.Group key={index}>
            <Styled.SkeletonGroupHeading height={scale100} />
            <div>
              {Array.from({ length: perkRows }, (_, perkIndex) => (
                <Styled.SkeletonPerk key={perkIndex}>
                  <SkeletonPillShape height={scale110} width={scale110} />
                  <Styled.SkeletonPerkText height={scale080} />
                </Styled.SkeletonPerk>
              ))}
            </div>
          </Styled.Group>
        ))}
      </Styled.Groups>
    </Styled.Section>
  );
};
